import { render, staticRenderFns } from "./SiestaHelp.vue?vue&type=template&id=1470b7de&scoped=true&"
import script from "./SiestaHelp.vue?vue&type=script&lang=js&"
export * from "./SiestaHelp.vue?vue&type=script&lang=js&"
import style0 from "./SiestaHelp.vue?vue&type=style&index=0&id=1470b7de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1470b7de",
  null
  
)

export default component.exports